"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [
// First Contract
{
  setAccountParam: '848b2592:accAddress accStatus accType limitPlus limitMinus',
  pledgeAccount: '6c343eef:accAddress amount *',
  setAllowance: 'd4e12f2e:spenderAddress amount',
  setDelegation: '75741c79:spenderAddress limit',
  setTaxAmount: 'f6f1897d:int',
  setTaxLegAmount: 'fafaf4c0:int',
  setTaxAccount: 'd0385b5e:accAddress',
  setOwnerAccount: 'f2fde38b:accAddress',
  setContractStatus: '88b8084f:status'
},
// Second Contract
{
  transferNant: 'a5f7c148:toAddress amount *',
  transferCM: '60ca9c4c:toAddress amount *',
  transferOnBehalfNant: '1b6b1ee5:fromAddress toAddress amount D',
  transferOnBehalfCM: '74c421fe:fromAddress toAddress amount D',
  askTransferFrom: '58258353:fromAddress amount',
  askTransferCMFrom: '2ef9ade2:fromAddress amount',
  payRequestNant: '132019f4:toAddress amount *',
  payRequestCM: '1415707c:toAddress amount *',
  rejectRequest: 'af98f757:toAddress',
  dismissAcceptedInfo: 'ccf93c7a:accAddress',
  dismissRejectedInfo: '88759215:accAddress'
}];
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7O2VBRWU7QUFDYjtBQUNBO0VBQ0VBLGVBQWUsRUFBRSw0REFBNEQ7RUFDN0VDLGFBQWEsRUFBRSw4QkFBOEI7RUFDN0NDLFlBQVksRUFBRSxnQ0FBZ0M7RUFDOUNDLGFBQWEsRUFBRSwrQkFBK0I7RUFDOUNDLFlBQVksRUFBRSxjQUFjO0VBQzVCQyxlQUFlLEVBQUUsY0FBYztFQUMvQkMsYUFBYSxFQUFFLHFCQUFxQjtFQUNwQ0MsZUFBZSxFQUFFLHFCQUFxQjtFQUN0Q0MsaUJBQWlCLEVBQUU7Q0FDcEI7QUFDRDtBQUNBO0VBQ0VDLFlBQVksRUFBRSw2QkFBNkI7RUFDM0NDLFVBQVUsRUFBRSw2QkFBNkI7RUFDekNDLG9CQUFvQixFQUFFLHlDQUF5QztFQUMvREMsa0JBQWtCLEVBQUUseUNBQXlDO0VBQzdEQyxlQUFlLEVBQUUsNkJBQTZCO0VBQzlDQyxpQkFBaUIsRUFBRSw2QkFBNkI7RUFDaERDLGNBQWMsRUFBRSw2QkFBNkI7RUFDN0NDLFlBQVksRUFBRSw2QkFBNkI7RUFDM0NDLGFBQWEsRUFBRSxvQkFBb0I7RUFDbkNDLG1CQUFtQixFQUFFLHFCQUFxQjtFQUMxQ0MsbUJBQW1CLEVBQUU7Q0FDdEIsQ0FDRjtBQUFBIiwibmFtZXMiOlsic2V0QWNjb3VudFBhcmFtIiwicGxlZGdlQWNjb3VudCIsInNldEFsbG93YW5jZSIsInNldERlbGVnYXRpb24iLCJzZXRUYXhBbW91bnQiLCJzZXRUYXhMZWdBbW91bnQiLCJzZXRUYXhBY2NvdW50Iiwic2V0T3duZXJBY2NvdW50Iiwic2V0Q29udHJhY3RTdGF0dXMiLCJ0cmFuc2Zlck5hbnQiLCJ0cmFuc2ZlckNNIiwidHJhbnNmZXJPbkJlaGFsZk5hbnQiLCJ0cmFuc2Zlck9uQmVoYWxmQ00iLCJhc2tUcmFuc2ZlckZyb20iLCJhc2tUcmFuc2ZlckNNRnJvbSIsInBheVJlcXVlc3ROYW50IiwicGF5UmVxdWVzdENNIiwicmVqZWN0UmVxdWVzdCIsImRpc21pc3NBY2NlcHRlZEluZm8iLCJkaXNtaXNzUmVqZWN0ZWRJbmZvIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25maWcvdHJhbnNhY3Rpb25zLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19